// #2121 v2 - Service HTTP del derivador: listado, tipos, doctores asignables, derivación individual y masiva
import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

class DeviceStudiesService extends AxiosService {
  constructor() {
    super('aspect-doctor-user');
  }

  getList = async (
    practiceId,
    {
      page = 0,
      limit = 15,
      datesort = 'desc',
      view = 'inbox',
      search = null,
      from = null,
      to = null,
      deviceType = null,        // string | string[]
      assignedDoctor = null,    // auth_user_id del médico
      cancelToken = null,
    } = {}
  ) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    params.set('datesort', datesort);
    params.set('view', view);
    if (search) params.set('search', search);
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    if (assignedDoctor) params.set('assignedDoctor', assignedDoctor);
    if (deviceType) {
      const arr = Array.isArray(deviceType) ? deviceType : [deviceType];
      if (arr.length > 0) params.set('deviceType', arr.join(','));
    }
    return await this.get(`/laboratory/devices?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
        practice: practiceId,
      },
      cancelToken,
    });
  };

  getTypes = async (practiceId, { cancelToken = null } = {}) => {
    return await this.get('/laboratory/devices/types', {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
        practice: practiceId,
      },
      cancelToken,
    });
  };

  getStats = async (practiceId, { cancelToken = null } = {}) => {
    return await this.get('/laboratory/devices/stats', {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
        practice: practiceId,
      },
      cancelToken,
    });
  };

  getAssignableDoctors = async (reportId, practiceId, { cancelToken = null } = {}) => {
    return await this.get(`/laboratory/devices/${reportId}/assignable-doctors`, {
      headers: {
        Authorization: `Bearer ${this.getToken()}`,
        practice: practiceId,
      },
      cancelToken,
    });
  };

  reassign = async (reportId, targetDoctorId, practiceId, note = null) => {
    return await this.put(
      `/laboratory/${reportId}/reassign`,
      { targetDoctorId, note },
      {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          practice: practiceId,
        },
      }
    );
  };

  bulkReassign = async (reportIds, targetDoctorId, practiceId, note = null) => {
    return await this.post(
      `/laboratory/devices/bulk-reassign`,
      { reportIds, targetDoctorId, note },
      {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          practice: practiceId,
        },
      }
    );
  };
}

export default new DeviceStudiesService();
// #2121 - End
